import { Layout } from "./components/Layout/Layout";

export default function App() {
  return (
    <div className="App">
      <Layout />
    </div>
  );
}
